import { BaseModel } from "../../shared/base.model";

export class DroneModel extends BaseModel {
    private _type: string = "";
    private _description: number = -1;

    public get type(): string {
        return this._type;
    }

    public set type(value: string) {
        this._type = value;
    }

    public get description(): number {
        return this._description
    }

    public set description(value: number) {
        this._description = value;
    }

    public static toModels(obj: string | Object[]): DroneModel[] {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let droneModel: DroneModel[] = [];

        for (const o2 of (<Object[]>obj2)) {
            droneModel.push(DroneModel.toModel(o2));
        }

        return droneModel;
    }

    public static toModel(obj: string | Object): DroneModel {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of DroneModel.
        return Object.assign(new DroneModel(), obj2);
    }
}    
